import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader, getUploadHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";
import { INewsManage } from "../_common/models/news/newsManage.model";
import { NewsFileTypeEnum } from "../_common/enum/newsFileType.enum";

const API_NAME = "news";

export const newsService = {
    getAll,
    get,
    submit(model?: any) {
        const formId = model instanceof FormData ? model.get("id") : model?.id;
        return formId ? put(model) : post(model)
    },
    disable,
    approve,
    reject
};

function getAll(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAll?${getQuery(query)}`, requestOptions).then(handleResponse);
}

function get(id: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/Get/?id=${id}`, requestOptions).then(handleResponse);
}

function post(model: any) {
    const requestOptions = { method: 'POST', headers: { "Authorization": getUploadHeader().Authorization }, body: model };
    return fetch(`${API_URL}/${API_NAME}/create`, requestOptions).then(handleResponse);
}

function put(model: any) {
    const requestOptions = { method: 'PUT', headers: { "Authorization": getUploadHeader().Authorization }, body: model };
    return fetch(`${API_URL}/${API_NAME}/update`, requestOptions).then(handleResponse);
}

function disable(id: any) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/disable/?id=${id}`, requestOptions).then(handleResponse);
}

function approve(id: any) {
    const requestOptions = { method: 'PUT', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/approve/?id=${id}`, requestOptions).then(handleResponse);
}

function reject(id: any) {
    const requestOptions = { method: 'PUT', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/reject/?id=${id}`, requestOptions).then(handleResponse);
}
